import React from 'react';

const ProjectsPagination = ({ currentPage, onNextPage, onPreviousPage, status, totalPages }) => {
  if (status !== 'success' || totalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-12 flex flex-col items-center gap-4">
      <p className="text-sm text-gray-500">
        Page {currentPage} of {totalPages}
      </p>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onPreviousPage}
          disabled={currentPage === 1}
          className="px-4 py-2 rounded-md border border-gray-300 text-gray-600 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>
        <button
          type="button"
          onClick={onNextPage}
          disabled={currentPage === totalPages}
          className="px-4 py-2 rounded-md border border-gray-300 text-gray-600 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ProjectsPagination;
